import type { GetVacanciesRequest, Vacancy } from '../types';
import { vacancyApi } from '../vacancyApi';
import { QueryKey } from '@shared/config';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import { keepPreviousData } from '@tanstack/react-query';

type UseGetVacanciesParams = GetVacanciesRequest & { enabled?: boolean };

export const useGetVacancies = ({
  enabled = true,
  ...params
}: UseGetVacanciesParams) => {
  return useInfiniteRequest<Vacancy>({
    queryKey: [QueryKey.GET_VACANCIES, params],
    queryFn: ({ pageParam }) =>
      vacancyApi.getVacancies({ ...params, ...pageParam }),
    initialPageParam: {
      perPage: params.perPage,
      page: params.page,
    },
    placeholderData: keepPreviousData,
    enabled,
  });
};
